import { fm } from 'Components/FormatMessage';
import { Container, Item } from 'Components/Grid';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import HistoryRowSubHeader from 'Components/HistoryRowSubHeader';
import { withFormContext } from 'Containers/FormContextHandler';
import { sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import colors from '../../../../config/theme/colors';

const AdverseEffectHistory = ({ document }: IOwnProps): React.JSX.Element => {
  return (
    <>
      <Container style={{ marginTop: '2rem' }}>
        <>
          <HistoryRowSubHeader header={fm('thalamotomyHifu.adverseEffects')} />
          <Container style={{ color: colors.tertiaryText }}>
            <Item xs={3}>{fm('general.date')}</Item>
            <Item xs={4}>{fm('thalamotomyHifu.adverseEffects')}</Item>
            <Item xs={5}>{fm('thalamotomyHifu.adverseEffectAdditionalInformation')}</Item>
          </Container>
          {document.adverseEffects
            ?.toSorted((n1, n2) => sortPartialDate(n2.date, n1.date))
            .map((ae, i) => (
              <Container key={i} style={{ margin: '1rem 0 0 0' }}>
                <Item xs={3} style={{ fontWeight: '600' }}>
                  {formatPartialDate(ae.date)}
                </Item>
                <Item xs={4} style={{ fontWeight: '600' }}>
                  {(ae.adverseEffects ?? []).length
                    ? ae.adverseEffects?.map((a, i) => (
                        <span key={a + i}>
                          {fm(`thalamotomyHifu.opts.${a}`)}
                          {i < (ae.adverseEffects ?? []).length - 1 ? ', ' : ''}
                        </span>
                      ))
                    : '-'}
                </Item>
                <Item xs={5} style={{ fontWeight: '600' }}>
                  {ae.additionalInformation ?? '-'}
                </Item>
              </Container>
            ))}
        </>
      </Container>
    </>
  );
};

const ThalamotomyHifuHistoryRowData = ({ document }: IOwnProps): React.JSX.Element => {
  const thalamotomy = document._type === 'thalamotomy' ? document : undefined;
  const hifu = document._type === 'hifu' ? document : undefined;

  return (
    <>
      {thalamotomy && (
        <>
          <Container>
            <Item xs={3}>
              <HistoryRowBasicItem
                header={fm('thalamotomyHifu.thalamotomy.treatmentHospital')}
                value={thalamotomy.placeOfOperation}
              />
            </Item>
            <Item xs={3}>
              <HistoryRowBasicItem
                header={fm('thalamotomyHifu.thalamotomy.treatmentType')}
                value={
                  thalamotomy.typeOfOperation
                    ? fm(`thalamotomyHifu.thalamotomy.opts.${thalamotomy.typeOfOperation}`)
                    : ''
                }
              />
            </Item>
          </Container>
          <AdverseEffectHistory document={thalamotomy} />
        </>
      )}
      {hifu && (
        <>
          <Container>
            <Item xs={3}>
              <HistoryRowBasicItem
                header={fm('thalamotomyHifu.hifu.treatmentTarget')}
                value={
                  <>
                    <span>{hifu.treatmentTarget ? fm(`thalamotomyHifu.hifu.opts.${hifu.treatmentTarget}`) : '-'}</span>
                    {hifu.treatmentTarget === 'other' && hifu.treatmentTargetOther && (
                      <span>: {hifu.treatmentTargetOther}</span>
                    )}
                  </>
                }
              />
            </Item>
          </Container>
          <AdverseEffectHistory document={hifu} />
        </>
      )}
    </>
  );
};

interface IOwnProps {
  document: IDocumentWithTypeV2<'thalamotomy' | 'hifu'>;
}

export default withFormContext(ThalamotomyHifuHistoryRowData);
